import React, {PureComponent} from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import {Logo} from '..';

import styles from './styles';

function handleContactClick(ev) {
  ev.preventDefault();

  window._urq.push(['Feedback_Open', 'submit/bug']);
}

function handleFeedbackClick(ev) {
  ev.preventDefault();

  window._urq.push(['Feedback_Open']);
}

export default class Footer extends PureComponent {

  render() {
    return (
      <div className={styles.footer}>
        <Helmet>
          <script async src="//platform.twitter.com/widgets.js" charset="utf-8"></script>
          <script async src="//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.10&appId=358572471250314" charset="utf-8"></script>
        </Helmet>
        <div className={styles.section}>
          <h4>{'Image Tools'}</h4>
          <Link to="/">{'Image Resize'}</Link>
          <Link to="/bulk-resize">{'Bulk Image Resize'}</Link>
          <Link to="/compress-images">{'Image Compressor'}</Link>
        </div>
        <div className={styles.section}>
          <h4>{'Features'}</h4>
          <Link to="/features/crop-photo">{'Photo Cropping'}</Link>
          <Link to="/features/photo-editor">{'Photo Editing'}</Link>
          <Link to="/features/compress-images">{'Photo Compressing'}</Link>
        </div>
        <div className={styles.section}>
          <h4>{'About'}</h4>
          <a href="#" onClick={handleContactClick}>{'Contact'}</a>
          {/* <Link to="/contact">{'Contact'}</Link> */}
          <Link to="/help">{'Help'}</Link>
          <a href="#" onClick={handleFeedbackClick}>{'Feedback'}</a>
        </div>
        <div className={styles.section}>
          <h4>{'Legal'}</h4>
          <Link to="/privacy">{'Privacy'}</Link>
          <Link to="/terms-of-service">{'Terms of Service'}</Link>
        </div>
        <div className={styles.section}>
          <Logo width={189} height={25} />
          <div className={styles.socialLinks}>
            <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" className="twitter-share-button" data-text="ImageResize.org is great for resizing and compressing image files" data-hashtags="imageresize" data-show-count="false">Tweet</a>
            <div className="fb-like" data-href="http://imageresize.org/" data-layout="button" data-action="like" data-size="small" data-show-faces="false" data-share="true"></div>
          </div>
          &copy; 2013 - {`${(new Date()).getFullYear()} Imageresize.org`}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx